import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` — only updates after `delay` ms
 * have passed without further changes. Used by search/filter inputs so
 * we don't fire an API call on every keystroke.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState<T>(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
